import React from 'react';

import { SVGComponentProps } from './svg.types';

const CodeSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
        <path
          d="M7.044 17.764V17.008C5.868 16.996 5.4 16.612 5.616 15.244L5.844 13.864C5.988 12.964 5.472 12.412 4.668 12.208C5.472 12.004 5.988 11.452 5.844 10.552L5.616 9.172C5.4 7.804 5.868 7.42 7.044 7.408V6.652C5.268 6.652 4.344 7.336 4.668 9.148L4.896 10.396C5.028 11.104 4.704 11.836 3.48 11.836V12.58C4.704 12.58 5.028 13.312 4.896 14.02L4.668 15.268C4.344 17.08 5.268 17.764 7.044 17.764Z"
          fill="#55585E"
        />
        <path
          d="M16.528 17.764C18.304 17.764 19.228 17.08 18.904 15.268L18.676 14.02C18.544 13.312 18.868 12.58 20.092 12.58V11.836C18.868 11.836 18.544 11.104 18.676 10.396L18.904 9.148C19.228 7.336 18.304 6.652 16.528 6.652V7.408C17.704 7.42 18.172 7.804 17.956 9.172L17.728 10.552C17.584 11.452 18.1 12.004 18.904 12.208C18.1 12.412 17.584 12.964 17.728 13.864L17.956 15.244C18.172 16.612 17.704 16.996 16.528 17.008V17.764Z"
          fill="#55585E"
        />
        <rect x="8" y="10" width="8" height="1" fill="#BCBEC2" />
        <rect x="8" y="12" width="8" height="1" fill="#BCBEC2" />
        <rect x="8" y="14" width="6" height="1" fill="#BCBEC2" />
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
      </svg>
    </span>
  );
};

export default CodeSVG;
